const getWaitTimeConfig = {
  name: 'waitTime',
  label: 'Wait Time',
  type: 'dropdown',
  optionsType: 'waitTimeOptionsInSecond',
  value: '',
};

export const dataSourceActions = [
  {
    name: 'dataSourceRestAPI',
    label: 'REST API',
    args: [
      {
        name: 'dataSourceId',
        label: 'REST API Data Sources',
        type: 'dropdown',
        optionsType: 'dsRestApi',
        value: '',
      },
      getWaitTimeConfig,
    ],
    // allowedTypes: ['number'],
  },
  {
    name: 'dataSourceDatabase',
    label: 'Database',
    args: [
      {
        name: 'dataSourceId',
        label: 'Database Data Sources',
        type: 'dropdown',
        optionsType: 'dsDatabase',
        value: '',
      },
      getWaitTimeConfig,
    ],
    // allowedTypes: ['number'],
  },
  {
    name: 'dataSourceGoogleSheet',
    label: 'Google Sheet',
    args: [
      {
        name: 'dataSourceId',
        label: 'Google Sheet Data Sources',
        type: 'dropdown',
        optionsType: 'dsGoogleSheet',
        value: '',
      },
      getWaitTimeConfig,
    ],
    // allowedTypes: ['number'],
  },
  {
    name: 'dataSourceAirtable',
    label: 'Airtable',
    args: [
      {
        name: 'dataSourceId',
        label: 'Airtable Data Sources',
        type: 'dropdown',
        optionsType: 'dsAirtable',
        multi: true,
        value: '',
      },
      getWaitTimeConfig,
    ],
    // allowedTypes: ['number'],
  },
  {
    name: 'dataSourceFirebaseRealtimeDatabase',
    label: 'Firebase Realtime Database',
    args: [
      {
        name: 'dataSourceId',
        label: 'Firebase Realtime Database Data Sources',
        type: 'dropdown',
        optionsType: 'dsFirebaseRealtimeDatabase',
        value: '',
      },
      getWaitTimeConfig,
    ],
  },
  // {
  //   name: 'dataSourceFirebaseFunction',
  //   label: 'Firebase Function',
  //   args: [
  //     {
  //       name: 'dataSourceId',
  //       label: 'Firebase Function Data Sources',
  //       type: 'dropdown',
  //       optionsType: 'dsFirebaseFunction',
  //       value: '',
  //     },
  //     getWaitTimeConfig,
  //   ],
  // },
  {
    name: 'dataSourceFirebaseCloudFirestore',
    label: 'Firebase Cloud Firestore',
    args: [
      {
        name: 'dataSourceId',
        label: 'Firebase Cloud Firestore',
        type: 'dropdown',
        optionsType: 'dsFirebaseCloudFirestore',
        value: '',
      },
      getWaitTimeConfig,
    ],
  },
];
